import { AcceptInviteForm } from "@/features/team/components/accept-invite-form";

export default function AcceptInvitePage() {
  return <AcceptInviteForm />;
}
